<template>
  <outro-template status="success" :hide-content="true" :show-exit-button="true" :memo="{ label: 'Arrivée et départ de collaborateur', link: 'files/memo7_collab.pdf' }">
    <template v-slot:title>
      Gérer l'arrivée ou le départ d'un collaborateur
    </template>
  </outro-template>
</template>

<script>
import OutroTemplate from '@shared/components/OutroTemplate'

export default {
  name: 'Outro',
  components: {
    OutroTemplate
  }
}
</script>

<style lang="scss">

</style>
